<template>
  <div class="cbaas-instruction-btn">
    <el-tooltip :placement="toolTipPlacement" :content="toolTip">
      <el-button type="text" :class="['btn', btnClass]" @click="onClick">
        <img :src="instructionIcon" />
      </el-button>
    </el-tooltip>
    <instruction-dialog
      :title="instructionTitle"
      :info="instructionInfo"
      :dialog-visible.sync="showInstructionDialog"
    ></instruction-dialog>
  </div>
</template>
<script>
import instructionIcon from '@/assets/images/instruction/instruction-icon.png'
import instructionDialog from './instructionDialog.vue'
export default {
  name: 'InstructionBtn',
  components: {
    instructionDialog
  },
  props: {
    id: {
      type: String,
      default: () => ''
    },
    toolTipPlacement: {
      type: String,
      default: () => 'left'
    },
    toolTip: {
      type: String,
      default: () => '使用场景说明'
    },
    instructionTitle: {
      type: String,
      default: () => '使用场景说明'
    },
    instructionInfo: {
      type: Array,
      default: () => ['使用场景说明']
    }
  },
  data() {
    return {
      instructionIcon,
      btnClass: '',
      intervalIns: null,
      intervalCount: 0,
      showInstructionDialog: false,
      instructionBtnsInfo: {}
    }
  },
  beforeMount() {
    try {
      this.instructionBtnsInfo = JSON.parse(localStorage.getItem('cbaas_instruction_btns')) || {}
    } catch (e) {
      console.log(e)
    }

    //用户未查看过功能使用场景说明，开启提示动画动画
    if (!this.id || !this.instructionBtnsInfo[this.id]) {
      let self = this
      this.intervalIns = setInterval(() => {
        if (self.intervalCount % 3 == 0) {
          self.btnClass = 'pop-up-btn'
          self.intervalCount = 0
        } else if (self.intervalCount % 3 == 1) {
          self.btnClass = ''
        }
        self.intervalCount++
      }, 1000)
    }
  },
  beforeDestroy() {
    //关闭动画
    if (this.intervalIns) {
      clearInterval(this.intervalIns)
      this.intervalIns = null
    }
  },
  methods: {
    onClick() {
      if (this.id) {
        //用户点击了查看按钮，关闭动画
        this.instructionBtnsInfo[this.id] = this.id
        localStorage.setItem('cbaas_instruction_btns', JSON.stringify(this.instructionBtnsInfo))

        if (this.intervalIns) {
          clearInterval(this.intervalIns)
          this.intervalIns = null
        }
      }

      this.showInstructionDialog = true
    }
  }
}
</script>
<style scoped lang="scss">
@import '@/styles/variables/theme';
@import '@/styles/variables/adaptation';
.cbaas-instruction-btn {
  @include adaptation(
    (
      --cbaas-instruction-btn-height: 32px
    )
  );
  height: var(--cbaas-instruction-btn-height);

  .btn {
    padding: 0;
    border: none;

    &:hover,
    &:focus {
      opacity: 0.8;
    }

    /deep/ span {
      display: flex;

      img {
        width: var(--cbaas-instruction-btn-height);
        height: var(--cbaas-instruction-btn-height);
      }
    }
  }

  .pop-up-btn {
    animation: popUp 300ms ease-in-out 0ms 3;
  }

  @keyframes popUp {
    0% {
      transform: translate(0px, 0px) scale(1, 1);
      transform-origin: 50% 100%;
    }

    8% {
      transform: translate(0px, 0px) scale(1.2, 0.8);
      transform-origin: 50% 100%;
    }

    10% {
      transform: translate(0px, 0px) scale(1, 1);
      transform-origin: 50% 100%;
    }

    50% {
      transform: translate(0px, -10px) scale(0.8, 1.2);
      transform-origin: 50% 100%;
    }

    90% {
      transform: translate(0px, 0px) scale(1, 1);
      transform-origin: 50% 100%;
    }

    92% {
      transform: translate(0px, 0px) scale(1.1, 0.9);
      transform-origin: 50% 100%;
    }

    100% {
      transform: translate(0px, 0px) scale(1, 1);
      transform-origin: 50% 100%;
    }
  }
}
</style>
